import { useSelector } from "react-redux";

export const useSelectedZone = () =>
  useSelector((state) => state.MapData.selectedZone.zone);
export const useSelectedZoneDetails = () =>
  useSelector((state) => state.MapData.selectedZone.details);
export const useSelectedZoneType = () =>
  useSelector((state) => state.MapData.selectedZone.type);
export const useVisibleAreas = () =>
  useSelector((state) => state.MapData.selectedZone.visibleAreas);
export const useEditableArea = () =>
  useSelector((state) => state.MapData.selectedZone.editableArea);
export const useVisiblleAllAreas = () =>
  useSelector((state) => state.MapData.selectedZone.visibleAllAreas);
export const useVisibleZoneList = () =>
  useSelector((state) => state.MapData.visibleZoneList);
export const useSelectedGroup = () =>
  useSelector((state) => state.MapData.selectedGroup);
export const useMapShapeData = () =>
  useSelector((state) => state.MapData.mapDetails.shapes);
export const useAddedShapedPoints = () =>
  useSelector((state) => state.MapData.addedShape.points);
export const useAddedShapedStatus = () =>
  useSelector((state) => state.MapData.addedShape.status);
export const useShapePropertiesColor = () =>
  useSelector((state) => state.MapData.shapeProperties.color);
export const useShapePropertiesType = () =>
  useSelector((state) => state.MapData.shapeProperties.type);
export const useViewShapeData = () =>
  useSelector((state) => state.MapData.mapDetails); // for API payload view
export const useDrivingRangeGPSCreateStatus = () =>
  useSelector((state) => state.MapData.driving_range_gps_create_status);
export const useDrivingRangeGPSUpdateStatus = () =>
  useSelector((state) => state.MapData.driving_range_gps_update_status);
export const useDrivingRangeGPSDetailsStatus = () =>
  useSelector((state) => state.MapData.driving_range_gps_details_status);
export const useIsNewShapeFlag = () =>
  useSelector((state) => state.MapData.isNewRange);
